<template>
  <b-col cols="12">
    <b-overlay :show="isLoading" rounded="sm">
      <b-table
        responsive
        small
        :items="traceability.data"
        :fields="fields"
        hover
        selectable
        @row-selected="onRowSelected"
        caption-top
        ref="tableManagement"
        stacked="sm"
      >
        <template v-if="beginReject" #cell(selected)="{ rowSelected }">
          <img
            :src="
              require(`@/assets/modules/permisos-sindicales/icons/tables/${
                rowSelected ? 'checkbox-selected' : 'checkbox'
              }.svg`)
            "
            :alt="rowSelected ? 'checkbox-selected' : 'checkbox'"
          />
        </template>

        <template #cell(management)="{ item }">
          <img
            :src="
              require(`@/assets/modules/permisos-sindicales/icons/${
                separateAudits(item).first.status
              }.svg`)
            "
            :alt="separateAudits(item).first.status"
          />
          {{ formatStateManagement(separateAudits(item).first) }}
        </template>

        <template #cell(updated_at)="{ item }">
          {{ formatUpdateAt(separateAudits(item).first.updated_at) }}
        </template>
      </b-table>
      <vue-pagination
        class="pagination-center"
        :data="traceability"
        :limit="5"
        @pagination-change-page="changePage"
      />
    </b-overlay>
  </b-col>
</template>

<script>
import { getTraceability } from "@/services/modules/permisos-sindicales/v2/licenses/service";
export default {
  props: {
    beginReject: {
      type: Boolean,
      default: false,
    },
    isReload: {
      type: Boolean,
      default: false,
    }
  },
  components: {
    VuePagination: () => import("laravel-vue-pagination"),
  },
  data() {
    return {
      isLoading: false,
      traceability: {},
      page: 1,
    };
  },
  computed: {
    fields() {
      return [
        {
          key: "selected",
          label: "",
          sortable: false,
        },
        {
          key: "core_employee.name",
          label: "Colaborador",
          sortable: false,
        },
        {
          key: "management",
          label: "Gestión del permiso",
          sortable: false,
        },
        {
          key: "updated_at",
          label: "Fecha y hora",
          sortable: false,
        },
      ];
    },
    id() {
      return Number(this.$route.params.id || 0);
    },
    formatUpdateAt() {
      return (date = "") => {
        return date
          ? this.$moment(date).format("DD [de] MMMM [de] YYYY [-] h:m A")
          : "Pendiente";
      };
    },
    formatStateManagement() {
      return ({ status, user }) => {
        const name = user ? user.name : null;
        const role = name && user.core_role ? user.core_role.name : null;
        const list = {
          approved: user
            ? `Aprobado por ${name} (${role})`
            : "Aprobación automatica",
          pending: "Pendiente",
          rejected: `Rechazado por ${name} (${role})`,
          retraction: "Retractación del permiso",
        };
        return list[status] ? list[status] : "<Sin Estado>";
      };
    },
    separateAudits() {
      return ({ audits, is_automatic_approval, status, updated_at }) => {
        const [first_, ...others] = audits;
        const responseUpdateAt =
          status === "approved" && is_automatic_approval
            ? updated_at
            : first_
            ? first_.updated_at
            : updated_at;
        const response = { status, updated_at: responseUpdateAt };
        return {
          first: is_automatic_approval ? response : first_ || response,
          others,
        };
      };
    },
  },
  watch: {
    beginReject() {
      if (this.beginReject === false)
        this.$refs.tableManagement.clearSelected();
    },
    isReload() {
      if(this.isReload) this.loadTraceability();
    }
  },
  methods: {
    async changePage(page = 1) {
      this.page = page;
      await this.loadTraceability();
    },
    onRowSelected(items) {
      if (this.beginReject) {
        this.$emit("selected:collaborator", items)
      } else {
        this.$refs.tableManagement.clearSelected();
      }
    },
    async loadTraceability() {
      const me = this;
      try {
        me.isLoading = true;
        const { result } = await getTraceability(me.id, {
          status: "rejected",
          page: me.page,
        });
        me.$emit('changeReload');
        if(result?.data?.length === 0) me.$emit('changeVisible')
        me.traceability = result;
      } catch (error) {
        console.log(error);
      } finally {
        me.isLoading = false;
      }
    },
  },
  mounted() {
    const me = this;
    me.loadTraceability();
  },
};
</script>

<style lang="scss" src="./styles.scss" />
